import styled from 'styled-components';
import { Box, Grid, Typography } from '@mui/material';

export const StyledBox = styled(Box)`
  height:100vh;
  display:flex;
  justify-content:center;
  align-items:center;
`;

export const ScrollGridItem = styled(Grid)`
  max-height: 400px;
  width:100%;
  overflow-Y:scroll;
  margin-bottom:10px;
  border:solid 1px rgba(0,0,0, .2);
  padding:20px;
`;

export const StyledTyphography = styled(Typography)`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #98A2B3;
`;

export const StyledHeading = styled(Typography)`
  font-weight: bold;
  font-size: 20px;
  line-height: 47px;
  color: #3D454B;
  text-align:center;
`;

